import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AppRoutes from "./AppRoutes";
import { useState } from "react";

const App = () => {
  const [filteredRecipes, setFilteredRecipes] = useState(null); // null = show all

  return (
    <div className="App">
      <AppRoutes filteredRecipes={filteredRecipes} />
      {/* <h6 className="Small-Font Justify-Center Green">
          As an Amazon Associate, I earn from qualifying purchases.
        </h6> */}
    </div>
  );
};

export default App;
